import { BlueprintBase } from '../blueprint-base';
import { BlueprintInstanceType } from '../shared.enums';
import { CountertopMaterial } from '../countertop-material/countertop-material.class';
import { KitchenDesignOptions } from '../kitchen-design-base';
import { kitchenMaterialData } from './kitchen-material.data';
import { Publish } from '../../decorators';
import { SurroundMaterial } from '../surround-material/surround-material.class';
import { KitchenMaterialDataIn, KitchenMaterialDataOut } from './types';

export class KitchenMaterial extends BlueprintBase<KitchenMaterialDataIn> {
	// readonly corner: MaterialCornerData;
	readonly countertop: CountertopMaterial;
	readonly surround: SurroundMaterial;

	constructor (options: KitchenDesignOptions<KitchenMaterialDataIn> = {}) {
		super(BlueprintInstanceType.KitchenMaterial, options);

		const { dataIn = null } = options;
		const data = kitchenMaterialData(dataIn);

		// this.corner = data.corner;
		this.countertop = new CountertopMaterial({ dataIn: data.countertop, parent: this });
		this.surround = new SurroundMaterial({ dataIn: data.surround, parent: this });

		// override by default for kitchen materials
		this.surround.override = true;

		this.setInitialized();
	}

	public setCountertop (key: string): boolean {
		return this.countertop.setMaterial(key);
	}

	public setSurround (key: string): boolean {
		return this.surround.setMaterial(key);
	}

	public serialize (): KitchenMaterialDataOut {
		return {
			// corner: this.corner,
			countertop: this.countertop.serialize(),
			surround: this.surround.serialize()
		};
	}
}
